import { GET_MENTAL_HEALTH_DETAILS, GET_ADMIN_MENTAL_HEALTH, GET_MENTAL_HEALTH_NOTES, REMOVE_MENTAL_HEALTH } from "./constants";

export const initialMentalNote = {
  observation: {
    name: "Observation",
    subSections: {},
  },
  mood: {
    name: "Mood",
    subSections: {},
  },
  cognition: {
    name: "Cognition",
    subSections: {},
  },
  perception: {
    name: "Perception",
    subSections: {},
  },
  thoughts: {
    name: "Thoughts",
    subSections: {},
  },
  recommendations: {
    name: "Recommendations",
    subSections: {},
  },
};

const mentalHealthIntialState = {
  mental_health_note: [],
  admin_mental_health: [],
  metal_health_details: JSON.parse(JSON.stringify(initialMentalNote)),
  isMentalHealth: false,
  isAdminNotes: false,
};

export const mentalHealthReducer = (state = mentalHealthIntialState, action = {}) => {
  switch (action.type) {
    case GET_MENTAL_HEALTH_DETAILS: {
      return {
        ...state,
        metal_health_details: action.payload,
      };
    }
    case GET_MENTAL_HEALTH_NOTES: {
      return {
        ...state,
        mental_health_note: action.payload,
        isMentalHealth: true,
      };
    }
    case GET_ADMIN_MENTAL_HEALTH: {
      return {
        ...state,
        admin_mental_health: action.payload,
        isAdminNotes: false,
      };
    }
    case REMOVE_MENTAL_HEALTH: {
      const newNote = state.metal_health_details.filter((item) => item.id !== action.payload);
      return {
        ...state,
        metal_health_details: [...newNote],
      };
    }
    default:
      return state;
  }
};
